<template>
  <div>
    <template v-if="getAvailableOrgsStatus || get_org_appeals_loading">
      <v-progress-linear indeterminate/>
    </template>
    <template v-else>
      <FilialCard
        v-for="card in filials"
        :value="card"
        :key="card.id"
        :blocked="block"
        :deleting="deleting.value && deleting.id === card.id"
        @change="openDialog($event, 'edit')"
        @delete="deleteFilial($event)"
      />
      <div class="pl-6 pb-4 pt-2" v-if="currentStage !== 5">
        <v-btn class="white__v-btn" :disabled="block" @click="openDialog(null, 'add')">Добавить</v-btn>
      </div>
    </template>
    <dialog-form2
      ref="dialog"
      :data-for-dialog="dataForDialog"
      :config="headersForDialog"
      :saving="savingData"
      :disabled="block"
      :additional-data="additionalData"
      @change="fetchDialogData($event)"
      @closing-dialog="clearDataForDialog"
    >
      <template #title>
        <h2 class="section-header__title">Структурное подразделение/филиал</h2>
      </template>
    </dialog-form2>
  </div>
</template>

<script>

import FilialCard from "@/components/cards/FilialCard";
import {mapGetters} from "vuex";
import DialogForm2 from "@/components/Dialogs/dialogForm2";
import {headersForDialog} from "@/containers/OrgFilials/config";
import AppealOrganizationController from "@/controllers/Organizations/AppealOrganizationController";

export default {
  name: "OrgFilialsContainer",
  components: {DialogForm2, FilialCard},
  props: {
    disabled: {
      type: Boolean || null,
      default: false
    }
  },
  data() {
    return {
      filials: [],
      dataForDialog: null,
      additionalData: null,
      savingData: false,
      deleting: {value: false, id: null},
      headersForDialog: headersForDialog
    }
  },
  computed: {
    block() {
      return this.disabled
    },
    ...mapGetters('spr', {
      getAvailableOrgs: 'getAvailableOrgs',
      getAvailableOrgsStatus: 'getAvailableOrgsStatus',
      getMainOrg: 'getMainOrg',
    }),
    ...mapGetters('appeals', {
      get_org_appeals_data: 'get_org_appeals_data',
      get_org_appeals_loading: 'get_org_appeals_loading',
      get_org_appeals_error: 'get_org_appeals_error',
    }),
    ...mapGetters('checkFilled', {currentStage: 'currentStage'}),
    subOrgs() {
      return this.getAvailableOrgs.filter(el => el.id !== el.ownerId)
    },
    changedFields() {
      return headersForDialog.map(el => el.dataField)
    }
  },
  watch: {
    get_org_appeals_loading() {
      this.initFilials();
    },
    getAvailableOrgsStatus() {
      this.initFilials()
    }
  },
  created() {
    if (this.getAvailableOrgsStatus === false)
      this.initFilials()
  },
  methods: {
    initFilials() {
      this.filials = this.subOrgs.map(el => {
        const payload = {...el};
        const appeal = this.get_org_appeals_data.data.find(el2 => el2.org?.id === el.id);
        if (appeal) {
          switch (appeal.accept) {
            case true:
              payload.status = 'ACCEPTED'
              break
            case false:
              payload.status = 'CANCELED'
              break
            default:
              payload.status = 'IN_PROGRESS'
              this.changedFields.forEach(el3 => payload[el3] = appeal[el3])
              break
          }
          payload.org = el.id;
          payload.id = appeal.id;
          payload.appealType = appeal.appealType;
        } else {
          payload.status = ''
          payload.org = el.id;
          payload.id = null;
        }
        return payload
      });
      const newFilials = this.get_org_appeals_data.data.reduce((acc, el) => {
        if (el.appealType === 'FILIAL_ORG_CREATE') {
          let status;
          switch (el.accept) {
            case true:
              status = 'ACCEPTED'
              break
            case false:
              status = 'CANCELED'
              break
            default:
              status = 'IN_PROGRESS'
              break
          }
          acc.push({...el, status: status})
        }
        return acc
      }, [])
      this.filials.push(...newFilials);
      //фильтрация принятый апелляций без присвоенного (руками) org.id
      this.filials = this.filials.filter(el => !((el.accept === true || el.accept === false) && el.org === null))
    },
    clearDataForDialog() {
      this.dataForDialog = null;
      this.additionalData = null;
    },
    /**
     * @param {'add' | 'edit'} typeAction
     * @param {Object} [row]
     * */
    async openDialog(row, typeAction = 'add') {
      console.log(row)
      if (typeAction === 'add') {
        this.additionalData = {
          owner: this.getMainOrg.id,
          type: this.getMainOrg.type.id,
          founder: this.getMainOrg?.founder?.id,
          inn: this.getMainOrg.inn,
          appealType: 'FILIAL_ORG_CREATE'
        };
        await this.$refs.dialog.openDialog();
        return;
      }
      this.additionalData = {
        id: row?.id ?? null,
        appealType: `FILIAL_ORG_UPDATE_${row?.org}`,
        org: row?.org,
        founder: row?.founder?.id,
        status: row.status,
        type: row.type?.id,
        inn: this.getMainOrg.inn,
        owner: this.getMainOrg.id
      };
      
      this.dataForDialog = {
        name: row.nameFull,
        nameShort: row.nameShort,
        address: row.address,
        kpp: row.kpp
      };
      
      await this.$refs.dialog.openDialog();
    },
    fetchDialogData(e) {
      this.savingData = true;
      AppealOrganizationController.setAppeal(e).then(() => {
        this.initFilials();
      })
        .catch(() => this.error = 'Ошибка отправления')
        .finally(() => this.savingData = false)
    },
    deleteFilial(e) {
      //заявка уже подана на эту строку
      this.deleting = {value: true, id: e.id};
      if (e.id) {
        AppealOrganizationController.deleteAppeal(e.id).then(() => {
          this.initFilials();
        })
          .finally(() => this.deleting = {value: false, id: null})
      } else {
        const payload = {
          id: null,
          appealType: `FILIAL_ORG_DELETE_${e?.org}`,
          org: e?.org,
          founder: e?.founder?.id,
          status: e.status,
          type: e.type?.id,
          inn: this.getMainOrg.inn,
          owner: this.getMainOrg.id,
          name: e.name,
          nameShort: e.nameShort,
          address: e.address,
          kpp: e.kpp
        }
        AppealOrganizationController.setAppeal(payload).then(() => {
          this.initFilials();
        }).finally(() => this.deleting = {value: false, id: null})
      }
    },
  },
}
</script>

<style scoped>

</style>